<template>
	<div class="AppSalesDropdown">
		<app-sales-performance v-if="isLocationPage" />
		<!-- <app-sales-tab /> -->
		<router-view />
		<!-- <app-pie-chart /> -->
		<!-- <app-table /> -->
		<!-- <app-wow-graph /> -->
		<!-- <AppAddStore /> -->
		<!-- <AppStoreDetails /> -->
	</div>
</template>

<script>
// import AppTable from "../appTable/AppTable";
// import AppPieChart from "../appPieChart/AppPieChart";
// import AppSalesTab from "../appSalesTab/AppSalesTab";
// import AppWowGraph from "../appWowGraph/appWowGraph";
import AppSalesPerformance from "../appSalesPerformanceCard/AppSalesPerformanceCard";
// import AppAddStore from "../appAddStore/AppAddStore";
// import AppStoreDetails from "../appStoreDetails/AppStoreDetails";
export default {
	name: "AppSalesDropdown",
	components: {
		// AppSalesTab,
		// AppWowGraph,
		// AppPieChart,
		// AppTable,
		AppSalesPerformance
		// AppAddStore,
		// AppStoreDetails
	},
	data() {
		return {
			// isLocationPage: this.$route.name == "Location" ? true : false
		};
	},
	computed: {
		isLocationPage() {
			return this.$route.name == "Location";
		}
	},
	mounted() {}
};
</script>
<style lang="scss" scoped>
.AppSalesDropdown {
	width: 100%;
}
</style>
